<template>
  <section class="save-comparison-modal">
    <modal-template>
      <template #card-title>
        {{ cardTitle }}
      </template>
      <template #comparison-data>
        <div
          v-if="computedComparison.location_object"
          class="usp"
        >
          <icon icon="x-fa-house" />
          <span>{{ computedComparison.location_object.display }}</span>
        </div>
        <slot name="market-usps" />
        <div
          v-if="computedComparison.friend_id"
          class="usp"
        >
          <icon icon="x-fa-user" />
          <span>{{ friendName }}</span>
        </div>
        <div
          v-if="receiver === 'other' && computedComparison.first_name"
          class="usp"
        >
          <icon icon="x-fa-user" />
          <span>Voor {{ computedComparison.first_name }}</span>
        </div>
      </template>
      <template #content>
        <div v-html="modalContent" />
      </template>
      <template #inputs>
        <div class="save-comparison-inputs">
          <TextInput
            id="remarks"
            v-model.lazy="computedComparison.remarks"
            :error="error.remarks"
            label="Korte beschrijving"
          />
          <TextareaInput
            id="message"
            v-model.lazy="computedComparison.message"
            type="textarea"
            label="Bericht toevoegen"
          />
        </div>
        <div class="bottom-button-container return-container">
          <button-icon-left
            type="cta-alt"
            label="Kies andere ontvanger"
            @click="previousStep"
          />
          <button-icon-right
            type="cta"
            :label="buttonLabel"
            @click="saveComparison"
          />
        </div>
      </template>
    </modal-template>
  </section>
</template>

<script>

import Icon from 'vue-elements/icon/Icon.vue';
import CardDefault from '../../../elements/card/default/cardDefault.vue';
import TextFieldElement from '../../../elements/field/text/default/textDefault.vue';
import ButtonIconRight from '../../../elements/button/icon-right/button-icon-right.vue';
import ModalTemplate from '../shared/ModalTemplate.vue';
import saveComparisonModal from '../assets/js/saveComparisonModal.js';
import LinkIconLeft from '../../../elements/link/icon-left/link-icon-left.vue';
import ButtonIconLeft from '../../../elements/button/icon-left/button-icon-left.vue';
import TextInput from '../../../../templates/vue-elements/input/TextInput.vue';
import TextareaInput from '../../../../templates/vue-elements/input/TextareaInput.vue';

export default {
    name: 'SaveComparisonModal',
    components: {
        TextareaInput,
        TextInput,
        ButtonIconLeft,
        LinkIconLeft,
        ModalTemplate,
        ButtonIconRight,
        TextFieldElement,
        CardDefault,
        Icon,
    },
    mixins: [saveComparisonModal],
    computed: {
        cardTitle() {
            if (this.receiver === 'self') {
                return 'Mijn vergelijking bewaren';
            }
            return 'Vergelijking delen';
        },
        modalContent() {
            if (this.receiver === 'self' && this.signedIn) {
                return '<p>Deze vergelijking wordt bewaard in je <span class="bold-text">Bewaarde vergelijkingen'
                    + `</span> in je Mijn Keuze overzicht. We sturen ook de resultaten van je vergelijking eenmalig naar <span class="bold-text">${this.confirmEmailAddress}</span>.</p> `
                    + '<p>Geef een korte beschrijving van deze vergelijking zodat je deze makkelijk herkent en voeg eventueel een bericht toe. </p>';
            }
            if (this.receiver === 'self') {
                return '<p>We sturen je éénmalig een overzicht van deze vergelijking op '
                    + `<span class="bold-text">${this.confirmEmailAddress}</span>.</p>`
                    + '<p>Voeg een korte beschrijving en bericht aan deze vergelijking toe. Deze worden meegestuurd in het overzicht van je vergelijking</p>';
            }
            if (this.receiver === 'friend') {
                return `<p>De vergelijking wordt bewaard in het <span class="bold-text">Mijn Keuze</span> profiel van ${this.friendName} en we sturen hem/haar een overzicht van deze vergelijking per mail.</p>`
                    + `<p>Voeg een korte beschrijving en bericht aan deze vergelijking toe. Zo herkent ${this.friendName} meteen waar het over gaat.</p>`;
            }
            if (this.receiver === 'other') {
                return '<p>We sturen eenmalig een overzicht van deze vergelijking naar '
                    + `<span class="bold-text">${this.comparison.first_name ?? this.comparison.email_address}</span>.</p>`
                    + `<p>Voeg een korte beschrijving en bericht aan deze vergelijking toe. Zo herkent ${this.friendName} meteen waar het over gaat.</p>`;
            }
            return 'We sturen de vergelijking naar je e-mailadres';
        },
    },
    methods: {
        previousStep() {
            this.$emit('previousStep');
        },
    },
};

</script>
